"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionOnFocusCompact = exports.positionOnFocusComfortable = exports.positionOnFocusDefault = exports.leftPositionOnFocus = exports.inputLabelTransformCompact = exports.inputLabelTransformComfortable = exports.inputLabelTransformDefault = exports.inputLabelShrink = exports.inputLabelReadOnly = exports.inputLabelDisabled = exports.inputLabelHover = exports.inputLabelFocused = exports.inputLabelCompactDensity = exports.inputLabelComfortableDensity = exports.inputLabelDefaultDensity = exports.inputLabelBase = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

var DEFAULT_LEFT_POSITION = 13;
var DEFAULT_TOP_POSITION = 20;
var COMFORTABLE_TOP_POSITION = 11;
var COMPACT_TOP_POSITION = 8;

var inputLabelBase = function inputLabelBase(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: 1;\n  display: block;\n  position: absolute;\n  left: ", "px;\n  pointer-events: none;\n  transition: transform 0.15s ease-out, background-color 0.15s ease-out,\n    color 0.3s ease-out;\n  transform-origin: 0;\n  line-height: 1em;\n  padding: 0 4px;\n  color: ", ";\n"])), DEFAULT_LEFT_POSITION, _stylitas.utilities.palette.color(theme, 'neutral06'));
};

exports.inputLabelBase = inputLabelBase;

var inputLabelTransformDefault = function inputLabelTransformDefault(_ref2) {
  var labelShrink = _ref2.labelShrink,
      size = _ref2.size;
  return labelShrink && size === 'default' && (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    transform: scale(1) translate(0, -27px);\n  "])));
};

exports.inputLabelTransformDefault = inputLabelTransformDefault;

var inputLabelTransformComfortable = function inputLabelTransformComfortable(_ref3) {
  var labelShrink = _ref3.labelShrink,
      size = _ref3.size;
  return labelShrink && size === 'comfortable' && (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    transform: scale(1) translate(0, -18px);\n  "])));
};

exports.inputLabelTransformComfortable = inputLabelTransformComfortable;

var inputLabelTransformCompact = function inputLabelTransformCompact(_ref4) {
  var labelShrink = _ref4.labelShrink,
      size = _ref4.size;
  return labelShrink && size === 'compact' && (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    transform: scale(1) translate(0, -15px);\n  "])));
};

exports.inputLabelTransformCompact = inputLabelTransformCompact;

var inputLabelDisabled = function inputLabelDisabled(_ref5) {
  var theme = _ref5.theme,
      disabled = _ref5.disabled;
  return disabled && (0, _stylitas.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral04'));
};

exports.inputLabelDisabled = inputLabelDisabled;

var inputLabelReadOnly = function inputLabelReadOnly(_ref6) {
  var theme = _ref6.theme,
      readOnly = _ref6.readOnly;
  return readOnly && (0, _stylitas.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral06'));
};

exports.inputLabelReadOnly = inputLabelReadOnly;

var inputLabelDefaultDensity = function inputLabelDefaultDensity(_ref7) {
  var size = _ref7.size;
  return size === 'default' && (0, _stylitas.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    top: ", "px;\n  "])), DEFAULT_TOP_POSITION);
};

exports.inputLabelDefaultDensity = inputLabelDefaultDensity;

var inputLabelComfortableDensity = function inputLabelComfortableDensity(_ref8) {
  var size = _ref8.size;
  return size === 'comfortable' && (0, _stylitas.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    top: ", "px;\n  "])), COMFORTABLE_TOP_POSITION);
};

exports.inputLabelComfortableDensity = inputLabelComfortableDensity;

var inputLabelCompactDensity = function inputLabelCompactDensity(_ref9) {
  var size = _ref9.size;
  return size === 'compact' && (0, _stylitas.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    top: ", "px;\n  "])), COMPACT_TOP_POSITION);
};

exports.inputLabelCompactDensity = inputLabelCompactDensity;

var inputLabelFocused = function inputLabelFocused(_ref10) {
  var theme = _ref10.theme,
      inputFocus = _ref10.inputFocus,
      variant = _ref10.variant;
  return inputFocus && (0, _stylitas.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    color: ", ";\n    ", "\n  "])), _stylitas.utilities.palette.color(theme, 'secondary05'), variant && "color: ".concat(_stylitas.utilities.palette.color(theme, variant), ";"));
};

exports.inputLabelFocused = inputLabelFocused;

var leftPositionOnFocus = function leftPositionOnFocus(_ref11) {
  var inputFocus = _ref11.inputFocus,
      readOnly = _ref11.readOnly;
  return inputFocus && !readOnly && (0, _stylitas.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    left: ", "px;\n  "])), DEFAULT_LEFT_POSITION - _consts.FOCUSED_BORDER_DELTA);
};

exports.leftPositionOnFocus = leftPositionOnFocus;

var positionOnFocusDefault = function positionOnFocusDefault(_ref12) {
  var size = _ref12.size,
      inputFocus = _ref12.inputFocus,
      readOnly = _ref12.readOnly;
  return inputFocus && !readOnly && size === 'default' && (0, _stylitas.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    top: ", "px;\n  "])), DEFAULT_TOP_POSITION - _consts.FOCUSED_BORDER_DELTA);
};

exports.positionOnFocusDefault = positionOnFocusDefault;

var positionOnFocusComfortable = function positionOnFocusComfortable(_ref13) {
  var size = _ref13.size,
      inputFocus = _ref13.inputFocus,
      readOnly = _ref13.readOnly;
  return inputFocus && !readOnly && size === 'comfortable' && (0, _stylitas.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    top: ", "px;\n  "])), COMFORTABLE_TOP_POSITION - _consts.FOCUSED_BORDER_DELTA);
};

exports.positionOnFocusComfortable = positionOnFocusComfortable;

var positionOnFocusCompact = function positionOnFocusCompact(_ref14) {
  var size = _ref14.size,
      inputFocus = _ref14.inputFocus,
      readOnly = _ref14.readOnly;
  return inputFocus && !readOnly && size === 'compact' && (0, _stylitas.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    top: ", "px;\n  "])), COMPACT_TOP_POSITION - _consts.FOCUSED_BORDER_DELTA);
};

exports.positionOnFocusCompact = positionOnFocusCompact;

var inputLabelHover = function inputLabelHover(_ref15) {
  var theme = _ref15.theme,
      inputHover = _ref15.inputHover,
      inputFocus = _ref15.inputFocus,
      disabled = _ref15.disabled;
  return inputHover && !inputFocus && !disabled && (0, _stylitas.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral07'));
};

exports.inputLabelHover = inputLabelHover;

var inputLabelShrink = function inputLabelShrink(_ref16) {
  var theme = _ref16.theme,
      labelShrink = _ref16.labelShrink,
      variant = _ref16.variant,
      _ref16$inputBackgroun = _ref16.inputBackground,
      inputBackground = _ref16$inputBackgroun === void 0 ? '#fff' : _ref16$inputBackgroun;
  return labelShrink && (0, _stylitas.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    font-weight: 600;\n    font-size: 12px;\n    background-color: ", ";\n    ", "\n  "])), inputBackground, variant && "color: ".concat(_stylitas.utilities.palette.color(theme, variant), ";"));
};

exports.inputLabelShrink = inputLabelShrink;